export default __webpack_public_path__ + "static/media/portfolio2.d7d1791e.jpg";